export class StateModel {
  name: string;
  abbreviation: string;
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/state.model.ts